module.exports = new __parcel__URL__("home.cd947a16.html").toString();